/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceNowMappingBase {
    getFixupPrototypeFunction() { return ServiceNowMappingBase.fixupPrototype; }

    static newInstance(model: Partial<ServiceNowMappingBase>): ServiceNowMappingBase {
        let obj = Object.assign(new ServiceNowMappingBase(), model);
        ServiceNowMappingBase.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceNowMappingBase>): ServiceNowMappingBase {
        if (!model) return null;
        return ServiceNowMappingBase.newInstance(<ServiceNowMappingBase> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceNowMappingBase) {
        if (!obj) return;

        models.ServiceNowMappingBase.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceNowMappingBase): boolean {
        Object.setPrototypeOf(obj, ServiceNowMappingBase.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.attribute_mapping) {
            for (let val of this.attribute_mapping) {
                models.ServiceNowConfigurationComponent.fixupPrototype(val);
            }
        }
        if (this.assignment_groups) {
            for (let val of this.assignment_groups) {
                models.ServiceNowAssignmentGroup.fixupPrototype(val);
            }
        }
    }

    attribute_mapping: Array<models.ServiceNowConfigurationComponent>;

    assignment_groups: Array<models.ServiceNowAssignmentGroup>;

}
